const DECIMAL_RE = /^\d+(?:\.(\d{1,2}))?$/;
export function campaignStatusLabel(status) {
    switch (status) {
        case 'active':
            return 'Активное';
        case 'hidden':
            return 'Неактивное';
        case 'deleted':
            return 'Удалённое';
    }
}
export function campaignOwnerLabel(owner) {
    return owner?.label || owner?.globalauth_id || 'Не указан';
}
export function bonusRangeHint(limits) {
    const { min_event_bonus: min, max_event_bonus: max } = limits;
    if (min !== null && max !== null)
        return `Допустимый бонус: от ${min} до ${max} ₽`;
    if (min !== null)
        return `Допустимый бонус: не меньше ${min} ₽`;
    if (max !== null)
        return `Допустимый бонус: не больше ${max} ₽`;
    return 'Допустимый бонус: без ограничений';
}
function decimalCents(value) {
    const match = value.match(DECIMAL_RE);
    if (!match)
        return null;
    const [whole = '0', fraction = ''] = value.split('.');
    return BigInt(whole) * 100n + BigInt(fraction.padEnd(2, '0'));
}
export function isBonusOutsideRange(value, limits) {
    const amount = decimalCents(value);
    if (amount === null)
        return false;
    const min = limits.min_event_bonus === null ? null : decimalCents(limits.min_event_bonus);
    const max = limits.max_event_bonus === null ? null : decimalCents(limits.max_event_bonus);
    return (min !== null && amount < min) || (max !== null && amount > max);
}
export function fastRegistrationLabel(until, now = new Date()) {
    if (!until)
        return 'Срок ещё не назначался';
    const date = new Date(until);
    if (Number.isNaN(date.getTime()))
        return 'Срок неизвестен';
    if (date.getTime() <= now.getTime())
        return 'Срок истёк';
    return `до ${date.toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    })}`;
}
